import axios from 'axios';
import { loginreq, req, postJson } from './axiosFun';
import http from '../utils/http';

//注册

export const signup = (params) => { return postJson( "/api/v1/register", params) };
export const sendregister = (params,type) => { return postJson( `/api/v1/register/send/${type==0?'sms':'email'}`, params) };
// 登录接口 
export const login = (params) => { return postJson( "/api/v1/hwa/login", params) };
export const smsLogin = (params) => {return postJson("/api/v1/hwa/smslogin", params)};
export const captcha = (params) => {return postJson("/api/v1/sms/captcha/login", params)};
export const scan = (params) => {return req('get',"/api/weixin/wxscan", params)};
export const checkloginscan = (params) => {return req('get',"/api/weixin/check/login", params)};

//登出接口
export const loginout = () => { return http.post( '/op1/logout',null) };

// 忘记密码接口
export const send = (params,type) => { return postJson( `/api/v1/forget/password/send/${type==0?'sms':'email'}`, params) };
export const register = () => {return req('get',"/api/v1/forget/password/register")};
export const verify = (params) => { return postJson( "/api/v1/forget/password/verify", params) };
export const reset = (params) => { return postJson( "/api/v1/forget/password/reset", params) };


/**
 * 用户管理 
 **/
// 获取用户信息
export const user = (params) => { return http.get( `/api/v1/user/${params}`) };
// 修改用户信息
export const usermodify = (params) => { 
    return http.put( `/api/v1/user/me`,params) 
};

// 修改密码
export const password = (params) => { 
    return http.put( `/api/v1/user/password`,params) 
};
//查询二维码是否已过期
export const checkscan = (params) => { return http.get( `/api/weixin/check/bind`,params) };
//更改手机号码-【发送】短信验证码验证是否是本人操作
export const changemobilesms1 = (params) => { 
    return http.post( `/api/v1/user/changemobile/sms1`,params) 
};
//更改手机号码-【校验】短信验证码验证是否是本人操作
export const changemobileveriry1 = (params) => { 
    return http.post( `/api/v1/user/changemobile/verify1`,params) 
};
//更改手机号码-【发送】短信验证码 到新手机号
export const changemobilesms2 = (params) => { 
    return http.post( `/api/v1/user/changemobile/sms2`,params) 
};
//更改手机号码-【校验】短信验证码验证新手机号是否是本人的
export const changemobileveriry2 = (params) => { 
    return http.post( `/api/v1/user/changemobile/verify2`,params) 
};
//更改邮箱-【发送】邮箱验证码 确认是本人操作
export const sendemailcapatch = (params) => { 
    return http.post( `/api/v1/user/changeemail/send/email`,params) 
};

//更改邮箱-【发送】短信验证码 确认是本人操作
export const changeemail = (params) => { 
    return http.post( `/api/v1/user/changeemail`,params) 
};

//上传头像
export const uploadAvatar = (params) => { 
    return http.post( `/api/v1/user/picture`,params) 
};



// WEBPACK FOOTER //
// ./src/api/userMG.js